module.exports = __webpack_public_path__ + "static/img/bankbanner-m.4848ffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bankbanner-m.png
// module id = eKM7
// module chunks = 0